import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import athletesService from '../services/athletesService'
import TopBar from '../components/TopBar'

const AthletesList = () => {
  const navigate = useNavigate()
  const [athletes, setAthletes] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchAthletes = async () => {
      try {
        const data = await athletesService.getAthletes()
        setAthletes(data)
      } catch (err) {
        console.error('Error fetching athletes:', err)
        setError('Failed to load athletes')
      } finally {
        setLoading(false)
      }
    }

    fetchAthletes()
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen bg-off">
        <TopBar />
        <div className="flex items-center justify-center" style={{ height: 'calc(100vh - 64px)' }}>
          <div style={{ color: 'var(--gold)', fontSize: '18px' }}>Loading athletes...</div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen bg-off">
        <TopBar />
        <div className="flex items-center justify-center" style={{ height: 'calc(100vh - 64px)' }}>
          <div style={{ color: '#E8507A', fontSize: '18px' }}>{error}</div>
        </div>
      </div>
    )
  }

  // Get initials for avatar
  const getInitials = (athlete) => {
    if (athlete.display_name) {
      return athlete.display_name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase()
    }
    return `${athlete.first_name[0]}${athlete.last_name[0]}`.toUpperCase()
  }

  // Color schemes for avatars
  const avatarColors = [
    { bg: 'rgba(232,80,122,0.15)', border: '2px solid #E8507A', text: '#E8507A' },
    { bg: 'rgba(34,197,94,0.1)', border: '2px solid rgba(34,197,94,0.4)', text: '#22C55E' },
    { bg: 'rgba(96,165,250,0.1)', border: '2px solid rgba(96,165,250,0.3)', text: '#60A5FA' },
    { bg: 'rgba(167,139,250,0.1)', border: '2px solid rgba(167,139,250,0.3)', text: '#a78bfa' }
  ]

  return (
    <div className="min-h-screen bg-off">
      <TopBar />
      
      <div className="hub-section" style={{ background: '#111115', minHeight: '100vh', paddingTop: '64px' }}>
        <div className="hub-card" style={{ 
          margin: '56px 20px 40px',
          border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: '12px',
          overflow: 'hidden',
          background: '#18181E'
        }}>
          <div className="hub-header" style={{
            padding: '20px 28px',
            borderBottom: '1px solid rgba(255,255,255,0.07)',
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            flexWrap: 'wrap'
          }}>
            <div>
              <div className="hub-title" style={{ fontSize: '14px', fontWeight: '700', color: '#FFFFFF' }}>
                Spring 2026 Window · IPA-Verified Data
              </div>
              <div className="hub-sub" style={{ fontSize: '13px', fontWeight: '400', color: '#6E6E7E' }}>
                {athletes.length} athletes · Filtered to: All Sports
              </div>
            </div>
            <div className="hub-filters" style={{ display: 'flex', gap: '8px', marginLeft: 'auto', flexWrap: 'wrap' }}>
              <div className="fchip active" style={{
                fontSize: '12px', fontWeight: '500', padding: '6px 14px',
                borderRadius: '100px', border: '1px solid rgba(232,80,122,0.25)',
                color: '#F06E90', cursor: 'pointer', background: 'rgba(232,80,122,0.1)',
                transition: 'all 0.15s'
              }}>
                All Sports
              </div>
              <div className="fchip" style={{
                fontSize: '12px', fontWeight: '500', padding: '6px 14px',
                borderRadius: '100px', border: '1px solid rgba(255,255,255,0.12)',
                color: '#6E6E7E', cursor: 'pointer', background: 'transparent',
                transition: 'all 0.15s'
              }}>
                Football
              </div>
              <div className="fchip" style={{
                fontSize: '12px', fontWeight: '500', padding: '6px 14px',
                borderRadius: '100px', border: '1px solid rgba(255,255,255,0.12)',
                color: '#6E6E7E', cursor: 'pointer', background: 'transparent',
                transition: 'all 0.15s'
              }}>
                Basketball
              </div>
              <div className="fchip" style={{
                fontSize: '12px', fontWeight: '500', padding: '6px 14px',
                borderRadius: '100px', border: '1px solid rgba(255,255,255,0.12)',
                color: '#6E6E7E', cursor: 'pointer', background: 'transparent',
                transition: 'all 0.15s'
              }}>
                Portal Only
              </div>
            </div>
          </div>
        
        <div className="hub-body" style={{ padding: '8px 12px' }}>
            {athletes.length === 0 ? (
              <div style={{
                textAlign: 'center',
                padding: '60px 20px',
                color: '#6E6E7E'
              }}>
                <div style={{
                  fontSize: '48px',
                  color: '#F06E90',
                  marginBottom: '16px',
                  opacity: 0.5
                }}>
                  👥
                </div>
                <h3 style={{
                  fontFamily: 'var(--font-d)',
                  fontSize: '18px',
                  color: '#FFFFFF',
                  marginBottom: '8px'
                }}>
                  No Athletes Registered Yet
                </h3>
                <p style={{
                  fontFamily: 'var(--font-b)',
                  fontSize: '14px',
                  color: 'rgba(255,255,255,0.6)'
                }}>
                  Check back later or complete an athlete registration to see them listed here.
                </p>
              </div>
            ) : (
              <>
                <div className="p-row th" style={{
                  display: 'grid',
                  gridTemplateColumns: '48px 1.8fr 0.9fr 0.9fr 0.9fr 1fr 88px',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  fontSize: '11px',
                  fontWeight: '600',
                  color: '#3A3A48',
                  letterSpacing: '0.04em',
                  textTransform: 'uppercase',
                  cursor: 'default',
                  paddingBottom: '8px'
                }}>
                  <div></div>
                  <div>Athlete</div>
                  <div>Sport</div>
                  <div>School</div>
                  <div>Position</div>
                  <div>Status</div>
                  <div></div>
                </div>
                
                {athletes.map((athlete, index) => {
                  const initials = getInitials(athlete)
                  const color = avatarColors[athlete.id ? athlete.id % avatarColors.length : 0] || avatarColors[0]
                  
                  return (
                    <div key={athlete.id} className="p-row" style={{
                      display: 'grid',
                      gridTemplateColumns: '48px 1.8fr 0.9fr 0.9fr 0.9fr 1fr 88px',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'background 0.15s',
                      borderBottom: index < athletes.length - 1 ? '1px solid rgba(255,255,255,0.03)' : 'none'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.03)'
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.background = 'transparent'
                    }}>
                      <div className="p-ava" style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: color.bg,
                        border: color.border,
                        fontSize: '14px',
                        fontWeight: '800',
                        color: color.text
                      }}>
                        {initials}
                      </div>
                      <div>
                        <div style={{
                          fontFamily: 'var(--font-d)',
                          fontSize: '14px',
                          fontWeight: '600',
                          color: '#FFFFFF',
                          marginBottom: '2px'
                        }}>
                          {athlete.display_name || `${athlete.first_name} ${athlete.last_name}`}
                        </div>
                        <div style={{
                          fontFamily: 'var(--font-b)',
                          fontSize: '12px',
                          color: '#6E6E7E'
                        }}>
                          {athlete.position || 'Not specified'} · {athlete.sports?.name || 'Unknown Sport'} · {athlete.schools?.name || 'Unknown School'}
                        </div>
                      </div>
                      <div>
                        <div style={{
                          fontFamily: 'var(--font-d)',
                          fontSize: '14px',
                          color: 'var(--gold)',
                          marginBottom: '2px'
                        }}>
                          {athlete.sports?.name || 'Unknown Sport'}
                        </div>
                      </div>
                      <div>
                        <div style={{
                          fontFamily: 'var(--font-d)',
                          fontSize: '14px',
                          color: 'var(--gold)',
                          marginBottom: '2px'
                        }}>
                          {athlete.schools?.name || 'Unknown School'}
                        </div>
                      </div>
                      <div>
                        <div style={{
                          fontFamily: 'var(--font-d)',
                          fontSize: '14px',
                          color: 'var(--gold)',
                          marginBottom: '2px'
                        }}>
                          {athlete.position || 'Not specified'}
                        </div>
                      </div>
                      <div>
                        <span className="badge badge-green" style={{
                          fontSize: '11px',
                          fontWeight: '500',
                          padding: '4px 10px',
                          borderRadius: '100px',
                          border: '1px solid rgba(34,197,94,0.25)',
                          color: '#22C55E',
                          background: 'rgba(34,197,94,0.1)'
                        }}>
                          Active
                        </span>
                      </div>
                      <button 
                        onClick={() => navigate(`/athletes/${athlete.id}`)}
                        className="row-btn" 
                        style={{
                          background: 'transparent',
                          border: '1px solid rgba(255,255,255,0.2)',
                          color: '#FFFFFF',
                          padding: '6px 12px',
                          borderRadius: '6px',
                          fontSize: '12px',
                          cursor: 'pointer',
                          transition: 'all 0.15s'
                        }}
                        onMouseOver={(e) => {
                          e.target.style.background = 'rgba(255,255,255,0.1)'
                          e.target.style.borderColor = 'rgba(255,255,255,0.3)'
                        }}
                        onMouseOut={(e) => {
                          e.target.style.background = 'transparent'
                          e.target.style.borderColor = 'rgba(255,255,255,0.2)'
                        }}
                      >
                        View →
                      </button>
                    </div>
                  )
                })}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AthletesList
